import React from "react";
import PropTypes from "prop-types";
import logoPicto from "../assets/logoPicto.svg";
import logoLabel from "../assets/logoLabel.svg";
import styled from "styled-components";

const StyledLogo = styled.div(({ size, $animate }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: size === "small" ? "200px" : "400px",
  animation: $animate ? "Zoom-in-out infinite 3s alternate" : "none",
}));

const StyledLabel = styled.div(({ size }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  width: size === "small" ? "200px" : "400px",
}));

const Logo = ({
  hasLabel = false,
  hasPicto = true,
  animate = false,
  size = "small",
}) => {
  const styles = {
    logoPicto: {
      minWidth: "100px",
      maxWidth: "100%",
      pointerEvents: "none",
    },
    logoLabel: {
      minWidth: "100px",
      maxWidth: "100%",
      pointerEvents: "none",
    },
  };

  return (
    <>
      {hasPicto && (
        <StyledLogo size={size} $animate={animate}>
          <img src={logoPicto} style={styles.logoPicto} alt="logo" />
        </StyledLogo>
      )}
      {hasLabel && (
        <StyledLabel size={size}>
          <img src={logoLabel} style={styles.logoLabel} alt="label" />
        </StyledLabel>
      )}
    </>
  );
};

Logo.propTypes = {
  hasLabel: PropTypes.bool,
  hasPicto: PropTypes.bool,
  animate: PropTypes.bool,
  size: PropTypes.string,
};

export default Logo;
